export const colors = {
  textLighBlackColor: '#3c4257',
  navbarBackColor: '#0f0f13',
  iconDarkGreyColor: 'rgba(110, 120, 138, 1)',
  primaryWhite: '#ffffff',
}
